'use client';

export interface TranscriptTurn {
  id: string;
  role: 'user' | 'satoshi';
  text: string;
}

/**
 * Presentational transcript list. Intentionally owns no height, width,
 * or scroll behaviour — the parent (chat-session-view / session-view)
 * supplies the scroll viewport and the scroll-to-bottom effect, so the
 * transcript simply fills whatever space the parent gives it.
 */
export function Transcript({ turns }: { turns: TranscriptTurn[] }) {
  if (turns.length === 0) return null;

  return (
    <div className="w-full space-y-4">
      {turns.map((turn) => (
        <div key={turn.id}>
          {turn.role === 'satoshi' ? (
            <div className="border-l-2 border-primary-bright pl-4">
              <p className="font-mono text-[10px] tracking-widest text-primary mb-1">
                SATOSHI
              </p>
              <p className="text-sm text-on-surface leading-relaxed">{turn.text}</p>
            </div>
          ) : (
            <div className="text-right">
              <p className="font-mono text-[10px] tracking-widest text-on-surface-variant mb-1">
                YOU
              </p>
              <p className="text-sm text-on-surface-variant leading-relaxed">{turn.text}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
